import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AutoLogoutService } from '@unified-ui/shared/auth-lib';

@Component({
    selector: 'unified-ui-main',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent {
    private _autoLogout = inject(AutoLogoutService);
}
